let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("56yEs")).then(() => parcelRequire('fSItB'));